import {date_format} from "@/utils/common";

// 日期格式化
const dateFormat = (value, format) => {
    if (value) {
        let formatString = "yyyy/MM/dd HH:mm"
        if (format) {
            formatString = format
        }
        return date_format(value, formatString)
    }
    return ""
}
// 数字格式化
const numberFormat = (value, num) => {
    if (value||value===0) {
        let number = 0
        if (num) {
            number = num
        }
        return value.toFixed(number)
    }
    return ""
}

export {dateFormat, numberFormat}